import tableOrigins from './tableOrigins';


export default {
  title: 'Origin Management',
  attributeName: 'origins',
  getURL: 'origin',
  createURL: '',
  refreshURL: 'origin',
  updateURL: 'originStatus',
  removeURL: 'origin',
  sessionParams: [],
  noArea: true,
  tableConfig: tableOrigins,
  sessionWebsocketParams: [],
  websocketEventChanel: 'origin',
  websocketItem: 'origin',
  autoUpdate: true,
  // websocketNavigation:'users_navigation',

};
